import { Images } from "assets";
import classNames from "classnames";
import { useEffect, useRef } from "react";
import { getDistanceBetweenDivs } from "shared/utils/helper";
import styles from "./style.module.scss";

const SecuritySection = () => {
  const mainContainerRef = useRef<HTMLDivElement>(null);
  const ref1 = useRef<HTMLDivElement>(null);
  const ref2 = useRef<HTMLDivElement>(null);
  const ref3 = useRef<HTMLDivElement>(null);
  const fillLineRef = useRef<HTMLDivElement>(null);
  const dottedLineRef = useRef<HTMLDivElement>(null);

  const handleResizeObserver = () => {
    if (ref1.current && ref2.current && ref3.current) {
      const distance = getDistanceBetweenDivs(ref1.current, ref2.current);
      fillLineRef.current!.style.height = `${distance}px`;
      const distance2 = getDistanceBetweenDivs(ref2.current, ref3.current);
      dottedLineRef.current!.style.height = `${distance2}px`;
    }
  };

  useEffect(() => {
    let elem = mainContainerRef.current;
    if (elem) {
      const observer: any = new ResizeObserver(handleResizeObserver).observe(
        elem
      );
      return () => {
        observer?.unobserve(elem);
      };
    }
  }, []);

  return (
    <section className={classNames(styles.customContainer)}>
      <div
        className={classNames("flex flex-col md:flex-row  gap-10 my-[80px]")}
        ref={mainContainerRef}
      >
        <div className={classNames(styles.imgContainer)}>
          <img src={Images.SecurityAsset1} alt="" />
        </div>
        <div
          className={classNames(
            "flex flex-col justify-between gap-8 md:gap-0 w-full"
          )}
        >
          <div className={classNames("flex flex-col gap-5 lg:gap-8")}>
            <h1 className={classNames(styles.title)}>
              <span>Security</span> and Compliance
            </h1>
            <p className={classNames(styles.description)}>
              We prioritize the security of your data. Our platform employs
              advanced encryption and secure storage protocols to ensure your
              job evaluations are protected. Compliance with industry standards
              is our top priority, giving you peace of mind.
            </p>
          </div>

          <div className={classNames("flex  gap-5 lg:gap-10")}>
            <div
              className={classNames(
                "flex flex-col justify-between items-center gap-5 lg:gap-10 ",
                styles.dotContainer
              )}
            >
              <div className={classNames(styles.inActiveDot)} ref={ref1} />

              <div
                className={classNames(styles.activeDot, "relative")}
                ref={ref2}
              >
                <div
                  className={classNames(styles.fillLine)}
                  ref={fillLineRef}
                />
                <div
                  className={classNames(styles.dottedLine)}
                  ref={dottedLineRef}
                />
                <div className={classNames(styles.blackDot)} />
              </div>
              <div className={classNames(styles.inActiveDot)} ref={ref3} />
            </div>
            <div
              className={classNames(
                "flex flex-col justify-between gap-5 lg:gap-10"
              )}
            >
              <h2 className={classNames(styles.pointTitle)}>Secure Storage</h2>
              <div className={classNames(styles.activePointContainer)}>
                <h2>Advanced Encryption</h2>
                <p>
                  Safeguard your data with cutting-edge encryption technology.
                </p>
              </div>
              <h2 className={classNames(styles.pointTitle)}>Compliance</h2>
            </div>
          </div>
          {/*
          <CustomButton
            title="Learn About Our Security"
            onClick={() => {
              window.open(routeConstant.privacy.path, "_blank");
            }}
          />
          */}
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
